<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <section data-reveal class="fade-in border-t border-[var(--color-border)]">
    <div
      class="mx-auto flex max-w-[800px] flex-col items-center justify-center gap-4 px-5 py-7 text-center md:flex-row md:gap-8 md:px-12"
    >
      <span class="text-sm font-medium text-[var(--color-text-muted)]">{{
        t("socialProof.builtBy")
      }}</span>
      <span class="hidden text-[var(--color-border)] md:inline" aria-hidden="true">·</span>
      <span class="text-sm font-medium text-[var(--color-text-muted)]">{{
        t("socialProof.usedDaily")
      }}</span>
      <span class="hidden text-[var(--color-border)] md:inline" aria-hidden="true">·</span>
      <span class="text-sm font-medium text-[var(--color-text-muted)]">{{
        t("socialProof.launching")
      }}</span>
    </div>
  </section>
</template>
